import React from 'react';
import SectionLayout from 'src/app/atoms/Layout/Section/SectionLayout';
import MakingTheSwitchImageAndContent from 'src/app/organisms/Homepage/MakingTheSwitchImageAndContent/MakingTheSwitchImageAndContent';

const MakingTheSwitch = (): JSX.Element => (
  <SectionLayout
    padding={['spacing-7xl', 'spacing-xl']}
    paddingSm={['spacing-4xl', 'spacing-xl']}
    maxWidth='width-3xl'
    data-track-section='making-the-switch'
  >
    <MakingTheSwitchImageAndContent />
  </SectionLayout>
);

export default MakingTheSwitch;
